import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p474825221175648256',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
